import { Button } from "@mui/material";
import TopGreen from "../components/atomic/ui/TopGreen";
import { useEffect, useState } from "react";
import WrapTable from "../components/history/WrapTable";
import module from "./History.module.css";
import { API, Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { getAccountDetail } from "../graphql/queries";
import fetchRewards from "../util/fetchRewards";
import { convertDate } from "../util/date";
import { judgeStatus } from "../config/rewardSetting";
import HistoryBanner from "../components/history/HistoryBanner";
import VALIDATE_REWARD_SETTING from "../util/validateRewardSetting";
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';

const TAB = {
  NOT_APPLIED: {
    label: "未振込報酬",
    value: "notApplied",
  },
  TOTAL: {
    label: "累計",
    value: "total",
  },
};

const columns = [
  {
    key: "date",
    label: "報酬年月日",
  },
  {
    key: "category",
    label: "区分",
  },
  {
    key: "status",
    label: "状態",
  },
  {
    key: "transferredLength",
    label: "件数",
  },
  {
    key: "transferredMoney",
    label: "報酬金額",
  },
];
const columnsTransfer = [
  {
    key: "date",
    label: "振込年月日",
  },
  {
    key: "status",
    label: "状態",
  },
  {
    key: "amount",
    label: "件数",
  },
  {
    key: "total",
    label: "報酬金額",
  },
  {
    key: "arrow",
    label: "",
  }
];

const History = () => {
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(TAB.NOT_APPLIED.value);
  const [user, setUser] = useState(null);
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [rows, setRows] = useState([]);
  const [transferRows, setTransferRows] = useState([]);
  const [isSavedValidBank, setIsSavedValidBank] = useState(true);
  const [page, setPage] = useState(0);

  const checkInputtedRewardSetting = async (user) => {
    try {
      const bankInfo = await API.graphql({
        query: getAccountDetail,
        variables: {
          user_id: user.attributes.sub,
        },
      });
      const { bank_name } = bankInfo.data.getAccountDetail;
      if (bank_name) {
      } else {
        setOpen(true);
      }
    } catch (e) {
      setOpen(true);
      console.log(e);
    }
  };

  const getBankInfo = async (user) => {
    const bankInfo = await API.graphql({
      query: getAccountDetail,
      variables: {
        user_id: user.attributes.sub,
      },
    });
    if (!bankInfo || !bankInfo.data || !bankInfo.data.getAccountDetail) return null;
    return bankInfo.data.getAccountDetail;
  };

  const isValidBankData = (bank) => {
    const { bank_name, bank_code, branch_name, branch_code, account_category, account_person_name, account_num } = bank;
    const isNotEmpty = bank_name && bank_code && branch_name && branch_code && account_category && account_person_name && account_num;
    if (!isNotEmpty) return false;
    const isValidAccountNum = VALIDATE_REWARD_SETTING.ACCOUNT_NUM(account_num);
    const isValidAccountName = VALIDATE_REWARD_SETTING.ACCOUNT_PERSON_NAME(account_person_name);
    if (isValidAccountNum === null && isValidAccountName === null) {
      return true;
    }
    return false;
  };

  const checkBankInfo = async (user) => {
    try {
      if (!user || !user.attributes || !user.attributes["custom:isFinishEKyc"]) return null;
      const bankInfo = await getBankInfo(user);
      if (!bankInfo) {
        setIsSavedValidBank(false);
        return null;
      }
      const isValid = isValidBankData(bankInfo);
      setIsSavedValidBank(isValid);
    } catch (e) {
      console.log(e);
    }
  };

  const getUser = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      setUser(user);
      await checkInputtedRewardSetting(user);
      await checkBankInfo(user);
    } catch (e) {
      console.log(e);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  const getJudgeStatus = (item) => {
    if (item.transfer_id) return "振込手続き中";
    if (item.judgeStatus === 2 || item.judgeStatus === 3) return <div className={module.linkText}><span>報酬対象外</span><ArrowCircleRightIcon /></div>;
    if (item.judgeStatus === 4 || item.judgeStatus === 5 || item.judgeStatus === 6) return <div className={module.linkText}><span>振込失敗</span><ArrowCircleRightIcon /></div>;
    const isBeforeMonth =
      new Date(item.createdAt).getMonth() < new Date().getMonth();
    if (isBeforeMonth) return "振込審査中";
    return "未振込";
  };

  const fetchReward = async () => {
    try {
      setIsLoading(true);
      const userData = await Auth.currentAuthenticatedUser();
      const result = await fetchRewards(userData.attributes.sub);
      if (!result.length) {
        setRows([]);
        setIsLoading(false);
        return null;
      }
      result.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt);
      }
      );
      const rewards = [];
      const transferredRewards = [];
      const transfers = [];

      result.forEach((item) => {
        const data = {
          ...item,
          date: convertDate(item.createdAt),
          status: getJudgeStatus(item),
          category: "紹介",
          transferredLength: 1,
          transferredMoney: item.amount,
        };
        if (item.judgeStatus === judgeStatus.success.value && !!item.transferredAt) {
          transferredRewards.push(data);
        } else {
          rewards.push(data);
        }
      });
      transferredRewards.forEach((item, i) => {
        const isMatched = transfers.some((transfer) => {
          return transfer.transferredAt === item.transferredAt;
        });
        if (isMatched) {
          const index = transfers.findIndex(
            (transfer) => transfer.transferredAt === item.transferredAt
          );
          transfers[index].amount++;
          transfers[index].total += item.amount;
        } else {
          transfers.push({
            date: convertDate(item.transferredAt),
            transferredAt: item.transferredAt,
            status: "振込済",
            amount: 1,
            total: item.amount,
          });
        }
      });

      setTransferRows(transfers);
      setRows(rewards);
      setIsLoading(false);
    } catch (e) {
      console.log(e);
      setIsLoading(false);
      alert("報酬の取得に失敗しました。");
    }
  };

  const setInitTab = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const tab = urlParams.get("tab");
    if (tab && tab === TAB.TOTAL.value) {
      setTabValue(tab);
    }
  };

  useEffect(() => {
    document.body.style.backgroundColor = "#f5f5f5";
    getUser();
    setInitTab();
    fetchReward();
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  const EachButton = ({ label, value }) => {
    const isSelected = tabValue === value;
    const selectedProps = isSelected
      ? {
        color: "white",
        backgroundColor: "#15B855",
      }
      : {};
    return (
      <Button
        sx={{
          color: "#15B855",
          backgroundColor: "white",
          padding: "3px 8px",
          borderRadius: "16px",
          lineHeight: "initial",
          fontWeight: "bold",
          fontSize: "0.8rem",
          margin: "0px 4px",
          position: "relative",
          bottom: "2px",
          ...selectedProps,
        }}
        onClick={() => { setTabValue(value); setPage(0); }}
      >
        {label}
      </Button>
    );
  };

  const calcTotal = () => {
    const isTotal = tabValue === TAB.TOTAL.value;
    const target = isTotal ? transferRows : rows;
    return target.reduce((acc, row) => {
      const money = isTotal ? row.total : row.transferredMoney;
      return acc + money;
    }, 0);
  };

  const total = calcTotal().toLocaleString();

  const handleRowClick = (row) => {
    if (tabValue === TAB.TOTAL.value) {
      navigate("/mypage/history/transfer?date=" + row.transferredAt);
    }
  };

  return (
    <div>
      {!isSavedValidBank && <HistoryBanner />}

      <TopGreen overrideClass={module.topOverride}>
        <div className={module.wrapTotal}>
          <span className={module.labelYen}>報酬合計</span>
          <span className={module.textYen}>{total}</span>
          <span>円</span>
        </div>
        <div>
          <div className={module.buttonGroup}>
            <EachButton
              label={TAB.NOT_APPLIED.label}
              value={TAB.NOT_APPLIED.value}
            />
            <EachButton label={TAB.TOTAL.label} value={TAB.TOTAL.value} />
          </div>
        </div>
      </TopGreen>
      <div className={module.container}>
        <div className={module.spacer} />
        <WrapTable
          page={page}
          setPage={setPage}
          rows={tabValue === TAB.NOT_APPLIED.value ? rows : transferRows}
          columns={
            tabValue === TAB.NOT_APPLIED.value ? columns : columnsTransfer
          }
          handleRowClick={handleRowClick}
          isLoading={isLoading}
          tab={tabValue}
        />
      </div>
    </div>
  );
};

export default History;
